import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { IApiResponse } from '../../../../shared/models/api-response';
import { convertStringDateToJSDate } from '../../../../shared/utilities/date-utility';
import { ISdBallotDetailDto } from '../models/sd/sd-ballot-detail';
import { IUpdateSdBallotNoteRequest } from '../models/sd/update-sd-ballot-note-request';
import { ISdVoteDto, ISdBallotVoteHistory, ISubmitSdBallotVoteRequest } from '../models/sd/sd-vote';
import { ISubmitSdBallotProxyVoteRequest } from '../models/sd/submit-sd-ballot-proxy-vote-request ';
import { IFinaliseSdBallotRequest } from '../models/sd/sd-finalise-ballot-request';
import { IBlobFile } from '../../../../shared/models/blob-file';
import { convertObjectToFormData } from '../../../../shared/utilities/form-data-utility';



@Injectable({
  providedIn: 'root'
})
export class SdBallotService {

  baseUrl: string = `${environment.servicesUrl.ballot}api/ballots/sd`;

  constructor(
    private http: HttpClient,
  ) { }

  public getBallotDetails(ballotId: number): Observable<IApiResponse<ISdBallotDetailDto>> {
    return this.http
      .get<IApiResponse<ISdBallotDetailDto>>(`${this.baseUrl}/${ballotId}`)
      .pipe(
        map((rawResponse) => {
          let response = { ...rawResponse };
          response.content.ballotStartDate = convertStringDateToJSDate(response.content.ballotStartDate as any);
          response.content.ballotEndDate = convertStringDateToJSDate(response.content.ballotEndDate as any);

          return response;
        })
      );
  }

  public updateBallotNote(request: IUpdateSdBallotNoteRequest): Observable<IApiResponse<number>> {
    return this.http.post<IApiResponse<number>>(`${this.baseUrl}/update-ballot-note`, request);
  }

  public placeVote(vote: ISubmitSdBallotVoteRequest): Observable<IApiResponse<number>> {
    return this.http.post<IApiResponse<number>>(`${this.baseUrl}/${vote.ballotId}/votes/${vote.ballotVoteId}`, vote);
  }

  public getVotes(projectId: number): Observable<IApiResponse<ISdVoteDto[]>> {
    return this.http.get<IApiResponse<ISdVoteDto[]>>(`${this.baseUrl}/projects/${projectId}/votes`);
  }

  public getDraftFiles(ballotId: number): Observable<IApiResponse<IBlobFile>> {
      return this.http.get<IApiResponse<IBlobFile>>(environment.servicesUrl.ballot + `api/blobs/ballots/sd/${ballotId}/drafts`);
  }

  public submitSdProxyVote(request: ISubmitSdBallotProxyVoteRequest) : Observable<HttpEvent<any>> {
    const formData = convertObjectToFormData(request);

    return this.http.post<HttpEvent<any>>(`${this.baseUrl}/${request.ballotId}/proxy-vote`, formData, {
      reportProgress: true,
      observe: 'events',
    });
  }

  public getSdBallotVoteHistory(ballotId: number, voteId: number) : Observable<IApiResponse<ISdBallotVoteHistory[]>> {
    return this.http.get<IApiResponse<ISdBallotVoteHistory[]>>(`${this.baseUrl}/${ballotId}/votes/${voteId}`);
  }

  public downloadBallotReport(projectId: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/projects/${projectId}/reports`, { responseType: 'blob' });
  }

  public finaliseSdBallot(request: IFinaliseSdBallotRequest): Observable<IApiResponse<any>> {
    return this.http.post<IApiResponse<any>>(`${this.baseUrl}/finalise`, request);
  }

}
